import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import VuexPersist from 'vuex-persist'
// import { tagsViewModule } from '@gcommon/plugin-tagview'
Vue.use(Vuex)
const SessionPersist = new VuexPersist({
  storage: window.sessionStorage
})

const modulesFiles = import.meta.globEager('./modules/*.ts')

const modules = Object.keys(modulesFiles).reduce((prev: any, next) => {
  const moduleName = next.replace(/(.*\/)*([^.]+).*/gi, '$2')
  prev[moduleName] = modulesFiles[next].default
  return prev
}, {})
export default new Vuex.Store({
  modules: {
    ...modules,
    // tagsViewModule
  },
  plugins: [SessionPersist.plugin],
  getters
})
